import React from "react";
import { IonCard, IonCol, IonRow } from "@ionic/react";
import BasicModal from "../../Modals/BasicModal";

/**
 * Shown when the user tries to leave an expanded entry/stabling/waivers card that has dirty form state.
 * Don't Save collapses without writing; Save Changes bumps `saveRequestKey` so the open card submits.
 */
interface UnsavedChangesModalProps {
    isOpen: boolean;
    onClose: () => void;
    /** Discard edits and collapse the open section. */
    onDontSave: () => void;
    /** Trigger the expanded card's save, then close. */
    onSaveChanges: () => void;
    /** Preview of the section the user is about to leave. */
    sectionInfo: { icon: string; title: string; subtitle?: string };
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({ isOpen, onClose, onDontSave, onSaveChanges, sectionInfo }) => {
    return (
        <BasicModal
            isOpen={isOpen}
            onClose={onClose}
            title="Unsaved Changes"
            footerButtons={[
                {
                    text: "DONT SAVE",
                    color: "danger",
                    onClick: onDontSave,
                },
                {
                    text: "SAVE CHANGES",
                    color: "success",
                    onClick: onSaveChanges,
                },
            ]}>
            <>
                <IonRow className="ion-justify-content-center mb-0">
                    <IonCol className="ion-text-center pb-0">
                        <h2 className="text-info font-weight-bold mb-0">Are you sure?</h2>
                    </IonCol>
                </IonRow>
                <IonRow className="ion-justify-content-center mt-0">
                    <IonCol className="ion-text-center pt-0">
                        <h5 className="text-danger font-weight-bold mt-0">Changes in this section have not been saved.</h5>
                    </IonCol>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <IonCol sizeXs="12" sizeMd="10">
                        {/* Mini replica of the section header so the user knows which card has unsaved work. */}
                        <IonCard className="rounded-3 mx-0 bg-lighter entry-info-card">
                            <div className="entry-info-card__row">
                                <div className="entry-info-card__icon">
                                    <span className="entry-info-card__icon-emoji">{sectionInfo.icon}</span>
                                </div>
                                <div className="entry-info-card__text">
                                    <div className="text-primary entry-info-card__title">{sectionInfo.title}</div>
                                    {sectionInfo.subtitle ? (
                                        <div className="text-info entry-info-card__subtitle entry-info-card__subtitle--tight">{sectionInfo.subtitle}</div>
                                    ) : null}
                                </div>
                            </div>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </>
        </BasicModal>
    );
};

export default UnsavedChangesModal;
